import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Get, Post } from 'Xhr/Xhr';
import { env } from 'env';
export const activeGateWayOnlinePayment = async (
  setGateWays
) => {
  setGateWays('loading');
  Get(
    `${process.env.REACT_APP_API_URL_API_ACTIVE_GETWAY_ONLINE_PAYMENT}`,
    true,
    {}
  ).then((response) => {
    if (response.data.resCode === 1) {
      setGateWays(response.data.Data);
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
